(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-prosucts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('article-prosucts')) return;

    class ArticleProsucts extends HTMLElement {
      constructor() {
        super();
        this.isDragging = false;
        this.isProgressDragging = false;
        this.hasMoved = false;
        this.startX = 0;
        this.startScroll = 0;
        this.onScroll = this.onScroll.bind(this);
        this.onProgressInput = this.onProgressInput.bind(this);
        this.onProgressPointerDown = this.onProgressPointerDown.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onResize = this.onResize.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.progress = this.querySelector('[data-progress]');
        if (!this.track || !this.progress) return;

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('pointerdown', this.onPointerDown);
        this.track.addEventListener('dragstart', this.onDragStart);
        this.track.addEventListener('click', this.onClick, true);
        this.progress.addEventListener('input', this.onProgressInput);
        this.progress.addEventListener('pointerdown', this.onProgressPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        window.addEventListener('resize', this.onResize);
        this.updateProgress();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('pointerdown', this.onPointerDown);
        this.track?.removeEventListener('dragstart', this.onDragStart);
        this.track?.removeEventListener('click', this.onClick, true);
        this.progress?.removeEventListener('input', this.onProgressInput);
        this.progress?.removeEventListener('pointerdown', this.onProgressPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        window.removeEventListener('resize', this.onResize);
      }

      get maxScroll() {
        return Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
      }

      updateProgress() {
        const maxScroll = this.maxScroll;
        this.progress.max = String(maxScroll);
        this.progress.value = String(Math.min(this.track.scrollLeft, maxScroll));
        this.progress.classList.toggle('is-hidden', maxScroll <= 1);
      }

      onScroll() {
        this.progress.value = String(this.track.scrollLeft);
      }

      onProgressInput() {
        this.track.scrollLeft = Number(this.progress.value);
      }

      onProgressPointerDown(event) {
        if (event.button !== 0) return;
        this.isProgressDragging = true;
        this.progress.setPointerCapture(event.pointerId);
        this.updateScrollFromProgressPointer(event);
        event.preventDefault();
      }

      updateScrollFromProgressPointer(event) {
        const progressRect = this.progress.getBoundingClientRect();
        const thumbWidth = Number(this.progress.dataset.thumbWidth);
        const availableWidth = Math.max(progressRect.width - thumbWidth, 1);
        const pointerPosition = event.clientX - progressRect.left - thumbWidth / 2;
        const progressRatio = Math.min(Math.max(pointerPosition / availableWidth, 0), 1);
        const scrollPosition = progressRatio * this.maxScroll;

        this.progress.value = String(scrollPosition);
        this.track.scrollLeft = scrollPosition;
      }

      onPointerDown(event) {
        if (event.button !== 0 || event.pointerType === 'touch') return;
        this.isDragging = true;
        this.hasMoved = false;
        this.startX = event.pageX;
        this.startScroll = this.track.scrollLeft;
        this.track.classList.add('is-dragging');
        event.preventDefault();
      }

      onPointerMove(event) {
        if (this.isProgressDragging) {
          this.updateScrollFromProgressPointer(event);
          return;
        }
        if (!this.isDragging) return;
        const distance = event.pageX - this.startX;
        if (Math.abs(distance) > 3) this.hasMoved = true;
        this.track.scrollLeft = this.startScroll - distance;
      }

      onPointerUp() {
        this.isProgressDragging = false;
        if (!this.isDragging) return;
        this.isDragging = false;
        this.track.classList.remove('is-dragging');
      }

      onDragStart(event) {
        event.preventDefault();
      }

      onClick(event) {
        if (!this.hasMoved) return;
        event.preventDefault();
        event.stopPropagation();
        this.hasMoved = false;
      }

      onResize() {
        this.updateProgress();
      }
    }

    customElements.define('article-prosucts', ArticleProsucts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
